import React, { useContext, Fragment, useState, useEffect } from 'react';
import { Button, Toast } from 'antd-mobile';
import moment from 'moment';
import styled from 'styled-components';
import { PlayOutline, StopOutline } from 'antd-mobile-icons';
import { featureEnabled, matchesPermission } from '../utils/permission-helpers';
import TotalTimeComponent from './TotalTimeComponent';
import { startWork } from '../api';
import WorkEntryPopup from './WorkEntryPopup';
import UserSelfContext from '../utils/self-context';

const ToastContent = styled.div`
	word-break: normal;
	text-align: center;
	width: 100%;
`;


function WorkTimeToggle(props) {
	const {
		parent,
		parentType
	} = props;
	const { userSelf, fetchSelf } = useContext(UserSelfContext);
	const [workEntry, setWorkEntry] = useState(userSelf.active_work_entry);
	const [workEntryPopupVisible, setWorkEntryPopupVisible] = useState(false);
	const [saving, setSaving] = useState(false);

	async function handleWorkEntryChange() {
		setWorkEntryPopupVisible(false);
	}

	const isActive = () => {
		if (!workEntry) {
			return false;
		}

		if (workEntry.parent_type !== parentType) {
			return false;
		}

		return parent.id ? parent.id === workEntry.parent_id : workEntry.user_id === userSelf.id;
	};

	useEffect(() => {
		setWorkEntry(userSelf.active_work_entry);
	}, [userSelf, parent.id]);

	const onStart = async () => {
		setSaving(true);
		try {
			await startWork({
				parent_id: parent.id || null,
				parent_type: parentType
			});

			await fetchSelf(true);

			setSaving(false);

			Toast.show({
				icon: 'success',
				content: 'Work started'
			});
		} catch (err) {
			setSaving(false);
			Toast.show({
				icon: 'fail',
				content: <ToastContent>
					Unable to start work. You might be already working.
				</ToastContent>
			});
		}
	};

	function getActivityButton() {
		if (workEntry && isActive()) {
			return <Button
				color='primary'
				size="mini"
				onClick={() => setWorkEntryPopupVisible(true)}
			>
				<StopOutline /> Stop
			</Button>;
		}

		return <Button
			color='primary'
			size="mini"
			loading={saving}
			disabled={!isActive() && workEntry}
			onClick={onStart}
		>
			<PlayOutline /> Start
		</Button>;
	}

	return (
		(
			featureEnabled(userSelf, 'work_entries_enabled') &&
			matchesPermission(userSelf, 'view_work_entries')) ?
			<Fragment>
				<TotalTimeComponent workEntry={isActive() ? workEntry : null} /> {getActivityButton()}
				<WorkEntryPopup
					workEntry={{
						...workEntry,
						work_end: moment().toISOString()
					}}
					visible={workEntryPopupVisible}
					onClose={() => setWorkEntryPopupVisible(false)}
					onSubmit={handleWorkEntryChange}
				/>
			</Fragment> : null
	);
}

export default WorkTimeToggle;
